import { Printer } from 'lucide-react'

import { ReceiptPrintDialog } from '@/shared/ui/receipt-print-dialog'
import { Button } from '@/shared/ui/button'

type StoreTicketItem = {
    name: string
    quantity: number
    totalPrice: number
    vat: number
}

interface StoreTicketModalProps {
    items: StoreTicketItem[]
    clientName: string
    onClose: () => void
}

export function StoreTicketModal(props: StoreTicketModalProps) {
    const { items, clientName, onClose } = props

    const total = items.reduce((sum, item) => sum + item.totalPrice, 0)
    const vatRates = Array.from(new Set(items.map(item => item.vat)))
    const vatTotals = vatRates.map(rate => {
        const subtotal = items.filter(item => item.vat === rate).reduce((sum, item) => sum + item.totalPrice, 0)
        return {
            rate,
            vatAmount: subtotal - subtotal / (1 + rate / 100),
        }
    })
    const baseAmount = total - vatTotals.reduce((sum, vat) => sum + vat.vatAmount, 0)
    const receiptItems = items.map(item => ({
        name: item.name.toUpperCase(),
        quantity: item.quantity,
        price: item.totalPrice,
    }))

    return (
        <ReceiptPrintDialog
            title='Ticket de tienda'
            description='Vista previa del ticket de artículos'
            documentLabel='TICKET TIENDA'
            items={receiptItems}
            vatTotals={vatTotals}
            baseAmount={baseAmount}
            total={total}
            customerLine={`Cliente: ${clientName}`}
            onClose={onClose}
            actions={handlePrint => (
                <>
                    <Button variant='outline' onClick={handlePrint} className='gap-2'>
                        <Printer className='h-4 w-4' />
                        Imprimir
                    </Button>
                    <Button onClick={onClose} className='gap-2 bg-black'>
                        Cerrar
                    </Button>
                </>
            )}
        />
    )
}
